import { Box } from "@mui/material";
import React from "react";

import { TextInput } from "components/common/TextInput";
import { Typography } from "new-components/typography/Typography";

interface MultichoiceDetailSettingsProps {
  choices: string[];
}

export function MultichoiceDetailSettings({ choices }: MultichoiceDetailSettingsProps) {
  return (
    <>
      <Typography variant="detail" textTransform="uppercase" fontWeight="bold" className="my-2 text-neutral-700">
        Answer Options:
      </Typography>
      <Box className="flex flex-col gap-3">
        {choices.map((choice) => (
          <Box key={choice}>
            <TextInput value={choice} disabled fullWidth />
          </Box>
        ))}
      </Box>
    </>
  );
}
